// One short, localized message for a failed payment. The raw Stripe/gateway text is kept as `detail`
// (shown only in a tooltip, and logged) so the user never sees the same failure twice in two forms.

const BY_CODE = {
    card_declined: 'Your card was declined. Try another card or payment method.',
    generic_decline: 'Your card was declined. Try another card or payment method.',
    do_not_honor: 'Your card was declined. Try another card or payment method.',
    insufficient_funds: 'Insufficient funds. Try another card or payment method.',
    expired_card: 'This card has expired. Use another card.',
    incorrect_cvc: 'The security code (CVC) is incorrect.',
    invalid_cvc: 'The security code (CVC) is incorrect.',
    incorrect_number: 'The card number is incorrect.',
    invalid_number: 'The card number is incorrect.',
    invalid_expiry_month: 'The expiry date is invalid.',
    invalid_expiry_year: 'The expiry date is invalid.',
    incorrect_zip: 'The postal code does not match your card.',
    lost_card: 'Your card was declined. Try another card or payment method.',
    stolen_card: 'Your card was declined. Try another card or payment method.',
    fraudulent: 'Your card was declined. Try another card or payment method.',
    card_not_supported: 'This card does not support this purchase. Use another card.',
    currency_not_supported: 'This card does not support this purchase. Use another card.',
    processing_error: 'The payment could not be processed. Please try again.',
    payment_intent_authentication_failure: 'Card verification failed. Please try again or use another card.',
    authentication_required: 'Card verification failed. Please try again or use another card.',
    setup_intent_authentication_failure: 'Card verification failed. Please try again or use another card.',
    rate_limit: 'Too many attempts. Please wait a moment and try again.',
    PAYMENT_PROCESSING: 'A payment for this bill is already processing.',
    PENDING_BANK_TRANSFER: 'This bill is waiting for your bank transfer.',
};

/**
 * @param {object|string} err  Stripe.js error ({type, code, decline_code, message}) or API error body ({error, error_code})
 * @param {function} t         i18n t()
 * @returns {{text: string, detail: string|null}}
 */
export function stripeErrorMessage(err, t) {
    if (!err) return { text: t('Payment failed. Please try another payment method.'), detail: null };
    const code = err.decline_code || err.error_code || err.code || null;
    const detail = typeof err === 'string' ? err : (err.error_detail || err.message || err.error || null);
    if (code && BY_CODE[code]) return { text: t(BY_CODE[code]), detail };
    if (err.type === 'card_error') return { text: t(BY_CODE.card_declined), detail };
    if (err.type === 'invalid_request_error' || err.type === 'api_error' || err.type === 'api_connection_error') {
        return { text: t('The payment could not be processed. Please try again.'), detail };
    }
    // Our own API already returns a localized sentence (error without a code)
    if (!code && typeof err.error === 'string' && err.error) return { text: err.error, detail: null };
    return { text: t('Payment failed. Please try another payment method.'), detail };
}
